var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconVideo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 25,
    fill: "#AF90FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.5875 12.5H28.4125V17.95H21.5875V12.5ZM30.2875 17.95V12.5C34.1625 12.5125 36.7 14.5125 37.3375 17.95H30.2875ZM12.5 19.825V30.2375C12.5 34.7875 15.2125 37.5 19.7625 37.5H30.2375C34.7875 37.5 37.5 34.7875 37.5 30.2375V19.825H12.5ZM28.05 30.225L25.45 31.725C24.9 32.0375 24.3625 32.2 23.8625 32.2C23.4875 32.2 23.15 32.1125 22.8375 31.9375C22.1125 31.525 21.7125 30.675 21.7125 29.575V26.575C21.7125 25.475 22.1125 24.625 22.8375 24.2125C23.5625 23.7875 24.4875 23.8625 25.45 24.425L28.05 25.925C29.0125 26.475 29.5375 27.25 29.5375 28.0875C29.5375 28.925 29 29.6625 28.05 30.225ZM12.6624 17.95C13.2999 14.5125 15.8374 12.5125 19.7124 12.5V17.95H12.6624Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVideo);
export default __webpack_public_path__ + "static/media/icon_video.ab16f80271f7afcb4b9729e48a44476e.svg";
export { ForwardRef as ReactComponent };